import React, { useCallback } from 'react';
import * as c from '../../ts/const';
import ImgPictures from '../components/img-pictures';
import { sendGtag } from '../../ts/modules/sendgtag';
const BundleBanner = () => {
    const onClick = useCallback(() => {
        sendGtag('BUNDLE_BANNER', c.IS_DEV);
    }, []);
    return (React.createElement("div", { className: 'bundle-banner sm:gutter', id: 'special-banner' },
        React.createElement(ImgPictures, { fileNameLarge: `./assets/img/banner/bundle-md`, fileNameSmall: `./assets/img/banner/bundle-sm`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL }),
        React.createElement("div", { className: 'bundle-banner-navbox' },
            React.createElement("a", { className: "btn-rounded btn-rounded-bundle", href: "https://www.jp.square-enix.com/digitalspecial/Bundle/", onClick: onClick, target: "_blank" }, "\u8A73\u7D30\u306F\u3053\u3061\u3089\u3092\u30C1\u30A7\u30C3\u30AF\uFF01"))));
};
export default BundleBanner;
